import { Button, ButtonSize, ButtonVariant } from "@bale/ui";
import { strings } from "intl/fa";
import React, { useCallback, useEffect, useState } from "react";
import { PhoneField } from "./phoneField/PhoneField";
import {
  GeneralErrors,
  GeneralValidators,
  useInputHandler,
} from "hooks/useInputHandler";
import commonStyles from "./../Login.module.scss"; //styles that are common in initial pages (phone,otp,register)
import Footer from "../../../commons/footer/Footer";
import classNames from "classnames";
import { useRequest } from "../../../../hooks/useRequest";
import { useAppSelector } from "../../../../utils/store";
import {
  requestOtpThunk,
  requestRegisterOtpThunk,
} from "../../../../core/auth/auth.thunk";
import { RequestOTPErrors } from "../../../../core/auth/auth.error";
import Modal from "../../../commons/modal/Modal";
import { sendYandexGoal, YandexGoal } from "../../../../yandex/yandex";
import phoneEntranceStyles from "./PhoneEntrance.module.scss";
import HintModal from "../hintModal/HintModal";

const PhoneEntrance: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { sendRequest, loading } = useRequest(requestOtpThunk);
  const { sendRequest: registerOtp, loading: registerOtpLoading } = useRequest(
    requestRegisterOtpThunk
  );
  const editingPhone = useAppSelector((state) => state.auth.phone);
  const [showLoginGuideModal, setShowLoginGuideModal] = useState(false);
  const [showNoBaleAccountModal, setShowNoBaleAccountModal] = useState(false);
  const phone = useInputHandler({
    numberOnly: true,
    rules: [GeneralValidators.phone],
    errorMessages: {
      [GeneralErrors.Phone]: strings.login.phone.error,
    },
    beforeBlur: (value: string) => value === "",
  });
  const handleSubmit = useCallback(() => {
    //todo: send otp api call
    //on api call succeed:
    if (phone.validate()) {
      sendRequest({ phone: phone.rawValue }).catch(
        (error: RequestOTPErrors) => {
          if (error === RequestOTPErrors.ErrNoBaleAccount) {
            setShowNoBaleAccountModal(true);
          }
        }
      );
      sendYandexGoal(YandexGoal.PhoneEntranceBtn);
    }
  }, [phone.rawValue]);

  // handle showing phone when returning from otp entrance
  useEffect(() => {
    phone.setValue(editingPhone);
  }, [editingPhone]);

  const closeNoBaleModal = useCallback(() => {
    setShowNoBaleAccountModal(false);
  }, []);

  const sendSmsOtp = useCallback(() => {
    registerOtp({ phone: phone.rawValue });
    sendYandexGoal(YandexGoal.RequestSmsBtn);
  }, [phone.rawValue]);

  return (
    <>
      <div className={commonStyles.wrapper}>
        <p className={commonStyles.BalePhone}>
          {strings.login.bale_phone[0]}
          <a
            href="https://ble.ir/advertisement_assistant_bot"
            target="_blank"
            rel="noreferrer"
            className={commonStyles.Link}
          >
            {strings.login.bale_phone[1]}
          </a>
          {strings.login.bale_phone[2]}
        </p>
        <PhoneField {...phone} onEnter={handleSubmit} />
      </div>

      <div className={phoneEntranceStyles.LoginProblem}>
        {strings.login.login_problem[0]}
        <span
          className={commonStyles.Link}
          onClick={() => setShowLoginGuideModal(true)}
        >
          {strings.login.login_problem[1]}
        </span>
      </div>

      <Footer className={classNames(commonStyles.wrapper, commonStyles.footer)}>
        <Button
          text={strings.common.button.submit_and_continue}
          size={ButtonSize.XLarge}
          disable={Boolean(phone.error) || !phone.value}
          onClick={handleSubmit}
          loading={loading}
        />
      </Footer>
      {showLoginGuideModal && (
        <HintModal onClose={() => setShowLoginGuideModal(false)} />
      )}
      {showNoBaleAccountModal && (
        <Modal
          title={strings.login.no_bale_account_modal.title}
          primaryLoading={registerOtpLoading}
          primaryButton={{
            onClick: sendSmsOtp,
            label: strings.register.title,
          }}
          onClose={closeNoBaleModal}
          secondaryButton={{
            onClick: closeNoBaleModal,
            label: strings.common.button.cancel,
            // variant: ButtonVariant.Outlined,
          }}
          content={strings.login.no_bale_account_modal.content}
        />
      )}
    </>
  );
};

export default PhoneEntrance;
